
const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const deleteGroup = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'DELETE_GROUP_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'DELETE_GROUP_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state, ...INITIAL_STATE }
  }
};
    
export default deleteGroup;